export default "__VITE_ASSET__BdmQwd$3__"